const customSizeForm = document.querySelector('.custom-size-form');

if (customSizeForm) {
  const customForm = customSizeForm.innerHTML;

  document.addEventListener('product:variant-change', function(event) {
    const variant = event.detail.variant;

    if (variant && variant.title.includes("Custom")) {
      customSizeForm.innerHTML = customForm;
      customSizeForm.style.display = 'block';
    } else {
      customSizeForm.innerHTML = '';
      customSizeForm.style.display = 'none';
    }
  });
}

// Custom ATC START

document.addEventListener("click", async function(e) {
  const btn = e.target.closest(".custom-product-card-atc");

  if (!btn) return;

  e.preventDefault();

  const originalText = btn.textContent;

  btn.disabled = true;
  btn.textContent = "Adding...";

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: btn.dataset.variantId,
        quantity: 1
      })
    });

    if (!response.ok) {
      throw new Error("Failed to add product");
    }

    btn.textContent = "Added ✓";

    document.dispatchEvent(
      new CustomEvent("quick-cart:open")
    );

    setTimeout(() => {
      btn.disabled = false;
      btn.textContent = originalText;
    }, 1500);

  } catch (error) {
    console.error(error);

    btn.disabled = false;
    btn.textContent = originalText;
  }
});

// Custom ATC END

/* PRODUCT CARD QUICK VIEW */

document.addEventListener("click", function(e) {

  const btn = e.target.closest(".custom-product-card-quickview");

  if (!btn) return;

  e.preventDefault();

  const productCard = btn.closest(".product-item");

  if (!productCard) return;

  const quickViewBtn = productCard.querySelector(".show-product-quickview");

  if (quickViewBtn) {
    quickViewBtn.click();
  }

});

/* END PRODUCT CARD QUICK VIEW */

/* Fast internal navigation hints */
(() => {
  const hintedUrls = new Set();
  const selector = [
    'a[href^="/products/"]',
    'a[href*="/products/"]',
    'a[href^="/collections/"]'
  ].join(",");

  const hint = (link) => {
    if (!link || link.target === "_blank" || link.classList.contains("no-transition")) return;

    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin || hintedUrls.has(url.href)) return;

    hintedUrls.add(url.href);

    const prefetch = document.createElement("link");
    prefetch.rel = "prefetch";
    prefetch.href = url.href;
    prefetch.as = "document";
    document.head.appendChild(prefetch);

    const image = link.closest(".product-item")?.querySelector("img");
    const imageUrl = image?.currentSrc || image?.src;
    if (imageUrl) {
      const imagePrefetch = document.createElement("link");
      imagePrefetch.rel = "prefetch";
      imagePrefetch.href = imageUrl;
      imagePrefetch.as = "image";
      document.head.appendChild(imagePrefetch);
    }
  };

  document.addEventListener("pointerover", (event) => {
    hint(event.target.closest(selector));
  }, { passive: true });

  document.addEventListener("touchstart", (event) => {
    hint(event.target.closest(selector));
  }, { passive: true });
})();
